import { FiArrowDownRight, FiArrowUpRight, FiCalendar } from "react-icons/fi";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export const DashboardHeader = ({ eyebrow, title, description, start = "2026-08-01", end = "2026-08-13", onStartChange, onEndChange, showActions = true }) => (
  <header className="dashboard-header">
    <div className="header-copy">
      <h1>{title}</h1>
      <p className="subtitle">{description}</p>
    </div>
    {showActions && <div className="header-actions">
        <label className="date-filter"><FiCalendar aria-hidden="true" /><span>Period</span><input type="date" aria-label="Start date" {...(onStartChange ? { value: start, onChange: onStartChange } : { defaultValue: start })} /><span>to</span><input type="date" aria-label="End date" {...(onEndChange ? { value: end, onChange: onEndChange } : { defaultValue: end })} /></label>
      </div>}
  </header>
);

export const MetricsGrid = ({ metrics }) => (
  <section className="metrics-grid" aria-label="Dashboard key metrics">
    {metrics.map(({ label, value, note, change, trend = "positive", icon: Icon, iconSrc, color = "green" }) => (
      <article className={`metric-card ${color}`} key={label}>
        <div className="metric-head"><span className="metric-label">{label}</span><span className="metric-icon">{iconSrc ? <img src={iconSrc} alt="" /> : <Icon aria-hidden="true" />}</span></div>
        <div className="metric-value">{value}</div>
        <div className="metric-foot">
          {change && <span className={`trend ${trend}`}>{trend === "positive" ? <FiArrowUpRight /> : <FiArrowDownRight />}{change}</span>}
          <span>{note}</span>
        </div>
      </article>
    ))}
  </section>
);

export const TrendChart = ({ data, dataKey = "value", color = "#126c3a", valuePrefix = "", valueLabel = "Value" }) => (
  <div className="chart-wrap" role="img" aria-label="Trend chart. Exact values are available in the chart tooltip.">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
        <defs><linearGradient id={`gradient-${dataKey}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity={0.24} /><stop offset="100%" stopColor={color} stopOpacity={0.01} /></linearGradient></defs>
        <CartesianGrid stroke="#e8eeea" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="label" axisLine={false} tickLine={false} tick={{ fill: "#758179", fontSize: 10 }} dy={8} />
        <YAxis axisLine={false} tickLine={false} tick={{ fill: "#758179", fontSize: 10 }} width={42} />
        <Tooltip formatter={(value) => [`${valuePrefix}${Number(value).toLocaleString()}`, valueLabel]} contentStyle={{ border: "1px solid #dfe7e2", borderRadius: 10, boxShadow: "0 8px 24px rgba(22,45,31,.1)", fontSize: 11 }} />
        <Area type="monotone" dataKey={dataKey} stroke={color} strokeWidth={2.5} fill={`url(#gradient-${dataKey})`} activeDot={{ r: 5, strokeWidth: 2, fill: "#fff" }} />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);
